import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiGetTestFileOld = async (route: string, key: string) => {
  const params: IApiParams = {
    url: `/getTestOldFile.php?baseName=${route}&key=${key}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
